/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

import type { MenuSkeletonItemProps } from '../../../../types/menu-base';
import messages from '../messages';

const DEFAULT_CONTENT_HEIGHT = 8;

const menuSkeletonStyles = cssMap({
	wrapper: {
		height: '32px',
		width: '100%',
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
});

export const MenuSkeletonItem = ({
	testId,
	contentHeight = DEFAULT_CONTENT_HEIGHT,
}: MenuSkeletonItemProps): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={menuSkeletonStyles.wrapper} alignBlock="center" testId={testId}>
			<Flex alignItems="center">
				<Skeleton testId="skeleton-item-v2" width="100%" height={contentHeight} isShimmering />
			</Flex>
			<VisuallyHidden>{formatMessage(messages.menuItemLoading)}</VisuallyHidden>
		</Stack>
	);
};
